import { type Enum } from '@webapp/infrastructure/types/Enum'

// Server metric selector for {report-base}/visualization/ requests and
// the active-tile state on detail views (BHV-023). Aggregate doughnut
// always requests USAGE; detail defaults: vendor/department/expense =
// SPENT, user = USAGE.
export const ReportChartMetrics = {
  SPENT: 'spent', // Total Spending / Total Expenditure (line)
  USAGE: 'usage', // Vendor/user/department/account-code usage (bar on detail)
  COUNT: 'count', // Items purchased (line)
  REIMBURSABLE: 'reimbursable', // Expense detail "Total Reimbursement" tile (line)
} as const

export type ReportChartMetric = Enum<typeof ReportChartMetrics>
